import React from 'react';
import { connect } from 'react-redux';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';
import LocationIcon from '@tradera/blueprint/theme/icons2/location.svg?jsx';
import { useUrlLocalizer } from 'tradera-lang/translate';
import { selectShowLocalizationRegionPicker } from 'tradera-state/shipping-region/selectors';
import { selectGeolocation } from 'tradera-state/member/selectors';
import { dismissLocalizationRegionPicker } from 'tradera-state/shipping-region/reducer';
import { onLocalizationShippingRegionSelected } from 'tradera-state/shipping-region/actions';
import ApplicationErrorBoundary from 'tradera-components/application-error-boundary/application-error-boundary';
import Flag from 'tradera-components/flag/flag';

const LocalizationRegionPicker = ({
    showLocalizationRegionPicker,
    dismissLocalizationRegionPicker,
    onLocalizationShippingRegionSelected,
    geolocation
}) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const onClick = () => {
        onLocalizationShippingRegionSelected({
            countryCodeIso2: geolocation.isoCode,
            currencyCode: geolocation.currency,
            toLocalizedUrl
        });
        dismissLocalizationRegionPicker();
    };

    return showLocalizationRegionPicker ? (
        <ApplicationErrorBoundary>
            <div className="tooltip tooltip-southwest localization-region-picker">
                <div className="tooltip_html">
                    <LocationIcon className="tooltip_icon icon" />
                    <div className="tooltip_content">
                        <p>
                            <strong>
                                Would you like to set your browsing destination
                                to <br />
                                <Flag
                                    className="mr-1"
                                    countryCodeIso2={geolocation.isoCode}
                                />
                                {geolocation.name}?
                            </strong>
                        </p>
                        <p className="mb-0">
                            <button
                                className="btn btn-outline-light btn-darkbtn-hover-light btn-sm text-nowrap"
                                onClick={onClick}>
                                Yes, set my location
                            </button>
                        </p>
                    </div>
                    <span
                        className="tooltip_close-icon"
                        onClick={dismissLocalizationRegionPicker}>
                        <CloseIcon className="icon icon-sm" />
                    </span>
                </div>
            </div>
        </ApplicationErrorBoundary>
    ) : null;
};

const mapStateToProps = state => ({
    showLocalizationRegionPicker: selectShowLocalizationRegionPicker(state),
    geolocation: selectGeolocation(state)
});

const mapDispatchToProps = {
    dismissLocalizationRegionPicker,
    onLocalizationShippingRegionSelected
};

export const ConnectedLocalizationRegionPicker = connect(
    mapStateToProps,
    mapDispatchToProps
)(LocalizationRegionPicker);
